<script>
import VipUser from '@/model/dataLayer/api/Vip/VipUser'
import IkDataTable from '@/plugins/EntityFrameWork/IkDataTable.vue'
import FileSaver from 'file-saver'
import dayjs from 'dayjs'
import BaseForm from '@/model/baseForm/BaseForm/BaseForm.vue'
import { VSelect } from 'vuetify/lib/components'
import { distributeVoucherType, getVoucherTypesList } from '@/model/dataLayer/api/Vip/VoucherTypes'
import { showSuccessMessage } from '@/model/utils/utils'
import UserDetailDialog from '@/views/AadenPages/VipPage/UserCenter/UserDetailDialog.vue'

export default {
  name: 'UserList',
  components: { UserDetailDialog, BaseForm, IkDataTable },
  data () {
    return {
      showUserDetail: false,
      detailInfo: null,
      editObject: null,
      showDistributedVoucherDialog: false,
      model: VipUser,
      voucherTypes: []
    }
  },
  computed: {
    schemas () {
      return [
        {
          key: 'distributedVoucher',
          name: 'distributedVoucher',
          component: VSelect,
          componentProps: {
            items: this.voucherTypes.map(it => {
              it.text = it.name
              it.value = it.id
              return it
            })
          }
        }
      ]
    }
  },
  async mounted () {
    await this.reload()
  },
  methods: {
    async goto (item) {
      this.detailInfo = item
      this.showUserDetail = true
    },
    async save (info) {
      await distributeVoucherType(info.id, info.distributedVoucher)
      this.showDistributedVoucherDialog = false
      await this.reload()
      showSuccessMessage(this.i18n.t('successful'))
    },
    async reload () {
      this.voucherTypes = await getVoucherTypesList()
    },
    distributedVoucher (item) {
      this.showDistributedVoucherDialog = true
      this.editObject = item
    },
    async download () {
      // await bindStore('e25a5670-4d9a-4397-b172-a25b7ebe2797', 12)
      const data = this.$refs.table.items
      let dataStrings = ['userName,email,phoneNumber,lastLoginAt,createTimestamp']
      data.forEach(it => {
        const res = [it.username, it.email, it.phoneNumber, dayjs(it.lastLoginAt).format('YYYY-MM-DD HH:mm:ss'), dayjs(it.createTimestamp).format('YYYY-MM-DD HH:mm:ss')]
        dataStrings.push(res.join())
      })
      dataStrings = dataStrings.join('\n')
      const blob = new Blob([dataStrings], { type: 'text/plain;charset=utf-8' })
      FileSaver.saveAs(blob, 'User List.csv')
    }
  }
}
</script>

<template>
  <div>
    <v-container>
      <ik-data-table
        ref="table"
        :custom-on-row-click="goto"
        :model="model"
        :use-default-action="false"
        entity-name="UserList"
        icon="mdi-cash-usd"
      >
        <template #item.distributedVoucher="{item}">
          <v-btn
            :height="!$vuetify.breakpoint.lgAndUp ? '40px' : ''"
            :icon="!$vuetify.breakpoint.lgAndUp"
            :style="!$vuetify.breakpoint.lgAndUp ? 'border-radius: 12px; background: #f57c00;' : ''"
            :width="!$vuetify.breakpoint.lgAndUp ? '40px' : ''"
            color="amber lighten-4 black--text"
            elevation="0"
            small
            @click.stop="distributedVoucher(item)"
          >
            <template v-if="!$vuetify.breakpoint.lgAndUp">
              <v-icon color="white">
                mdi-cog
              </v-icon>
            </template>
            <template v-if="$vuetify.breakpoint.lgAndUp">
              <div
                :class="!$vuetify.breakpoint.lgAndUp ? 'text-truncate' : ''"
                :style="!$vuetify.breakpoint.lgAndUp ? 'max-width: 100px;' : ''"
              >
                {{ '分发优惠券' }}
              </div>
            </template>
          </v-btn>
        </template>
        <template #item.lastLoginDisplay="{item}">
          {{ item.lastLoginAt | beautifulTimeWithYear }}
        </template>
        <template #item.createTimestampDisplay="{item}">
          {{ item.createTimestamp | beautifulTimeWithYear }}
        </template>
        <template #primaryButton>
          <v-btn
            color="amber lighten-4 black--text"
            elevation="0"
            @click="download"
          >
            <v-icon left>
              mdi-export
            </v-icon>
            {{ $t('export') }}
          </v-btn>
        </template>
      </ik-data-table>
    </v-container>
    <v-dialog
      v-model="showDistributedVoucherDialog"
      max-width="600px"
    >
      <base-form
        :editing-object="editObject"
        :schema="schemas"
        @close="showDistributedVoucherDialog=false"
        @submit="save"
      />
    </v-dialog>
    <v-dialog
      v-model="showUserDetail"
      max-width="600px"
    >
      <user-detail-dialog
        :info="detailInfo"
      />
    </v-dialog>
  </div>
</template>

<style scoped>

</style>
